"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactJsPagination = _interopRequireDefault(require("react-js-pagination"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var AppTablePagination = /*#__PURE__*/function (_React$Component) {
  _inherits(AppTablePagination, _React$Component);

  function AppTablePagination() {
    _classCallCheck(this, AppTablePagination);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppTablePagination).apply(this, arguments));
  }

  _createClass(AppTablePagination, [{
    key: "render",
    value: function render() {
      var _this = this;

      if (!this.props.paginate) return null;
      if (!this.props.pagination || this.props.pagination.total_pages === 0) return null;
      var pages = this.props.pagination;
      if (pages.total_pages === 1) return null;
      return _react["default"].createElement("div", {
        className: "pull-right"
      }, _react["default"].createElement("span", null, "Total items: ", pages.total_items), _react["default"].createElement(_reactJsPagination["default"], {
        hideFirstLastPages: true,
        innerClass: "pagination pull-right",
        itemClass: "page-item",
        itemClassFirst: "page-item",
        itemClassNext: "page-item",
        itemClassPrev: "page-item",
        linkClass: "page-link",
        linkClassFirst: "page-link",
        activePage: this.props.pagination.page,
        itemsCountPerPage: pages.limit,
        totalItemsCount: pages.total_items,
        pageRangeDisplayed: 10,
        onChange: function onChange(pageNumber) {
          return _this.props.onPageChanged(pageNumber);
        }
      }));
    }
  }]);

  return AppTablePagination;
}(_react["default"].Component);

exports["default"] = AppTablePagination;
AppTablePagination.defaultProps = {
  onPageChanged: function onPageChanged(page) {
    return console.log('changing page to ' + page);
  },
  paginate: true
};